export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_03.d934a080.jpg";